/* app/js/src/components/recording/recording-scheduler/add-or-edit-recording-job/add-or-edit-recording-job.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.container .settings .settings-panel::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.container .settings .settings-panel::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.container .settings .settings-panel::-webkit-scrollbar-corner {
  background: transparent;
}
.container .settings .settings-panel::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.container .settings .settings-panel::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.container .settings .settings-panel::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.container .settings .settings-panel::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.container .settings .settings-panel::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.container .settings .settings-panel::-webkit-scrollbar-thumb {
  border-width: 0;
}
:host {
  height: 100%;
  width: 100%;
}
.container {
  margin: 10px;
  height: 80vh;
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: 3px 2px 26px 2px rgba(0, 0, 0, 0.5);
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
.container .header {
  height: 53px;
  width: 100%;
  background-color: #f1f3f4;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
  align-items: center;
  border-bottom: 3px solid #dde3e7;
  padding: 0 15px 0 30px;
}
.container .header span {
  font-weight: 700;
}
.container .header .close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: transform 0.2s;
}
.container .header .close:hover {
  transform: translate(2px, 0) scale(1.4);
}
.container .settings {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background-color: #eef2f6;
}
.container .settings small {
  color: #ef5350;
  font-size: 11px;
}
.container .settings .settings-panel {
  padding: 10px 40px;
  background-color: #ffffff;
  -webkit-flex: 3 0 0;
  -ms-flex: 3 0 0;
  flex: 3 0 0;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}
.container .settings .settings-panel .section {
  flex: 1 1 auto;
  font-size: 14px;
  font-weight: 700;
  padding-top: 20px;
  letter-spacing: -0.1px;
  color: #232f3a;
  width: 35vw;
  border-bottom: 1px solid #c6d2df;
}
.container .settings .settings-panel .property {
  margin: 15px 0;
  margin-right: 50px;
  display: flex;
  font-size: 12px;
  flex-direction: column;
}
.container .settings .settings-panel .property input {
  height: 30px;
  border-radius: 4px;
  background-color: #ffffff;
  font-size: 12px;
  border: 1px solid #e1e6eb;
  color: #232f3a;
  outline: 0;
  width: 250px;
  padding: 0 12px;
}
.container .settings .settings-panel .sources {
  display: flex;
  flex-direction: row;
  display: flex;
  -webkit-transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.2s;
  transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.2s;
  margin-top: 5px;
  padding: 5px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  border: 1px solid #e1e6eb;
  -webkit-border-radius: 2px;
  width: 35vw;
  min-height: 45px;
  border-radius: 2px;
  background: #ffffff;
}
.container .settings .settings-panel .sources .empty {
  margin: auto;
  color: #7d8fa1;
}
.container .settings .settings-panel .sources .edit-video-id-message {
  position: absolute;
  width: 35vw;
  text-align: center;
  line-height: 31px;
  color: #7d8fa1;
}
.container .settings .settings-panel .sources .source {
  padding: 9px;
  margin: 2px;
  background-color: #f1f3f4;
  border-radius: 4px;
  line-height: 11px;
  display: flex;
  font-family: OpenSans;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #232f3a;
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.container .settings .settings-panel .sources .source.edited {
  background-color: #64cfff !important;
}
.container .settings .settings-panel .sources .source .source-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 6px;
  gap: 4px;
}
.container .settings .settings-panel .sources .source .source-buttons .remove svg {
  display: block;
  cursor: pointer;
  position: static;
  left: auto;
  bottom: auto;
}
.container .settings .settings-panel .sources .source .source-gear {
  cursor: pointer;
}
.container .settings .settings-panel .sources .source .source-gear ::ng-deep svg {
  display: block;
  cursor: pointer;
  width: 7px;
  height: 7px;
}
.container .settings .settings-panel .sources .source .remove svg {
  display: block;
  cursor: pointer;
  left: 5px;
  bottom: 5px;
  position: relative;
}
.container .settings .settings-panel .sources .source .platform-name {
  font-weight: 700;
}
.container .settings .settings-panel .sources .source .platform-picker {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 6px;
  z-index: 20;
  background: #ffffff;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  padding: 12px;
  min-width: 220px;
  cursor: default;
}
.container .settings .settings-panel .sources .source .platform-picker ::ng-deep icn-dropdown {
  display: block;
  width: 100%;
}
.container .settings .settings-panel .sources .source .platform-picker header {
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 8px;
  color: #232f3a;
}
.container .settings .settings-panel .sources .source .platform-picker .loading {
  font-size: 12px;
  color: #7d8fa1;
  padding: 6px 0;
}
.container .settings .settings-panel .sources .source .platform-picker footer {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 10px;
}
.container .settings .settings-panel .sources .source .platform-picker footer button {
  height: 26px;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid #e1e6eb;
  background: #ffffff;
  color: #232f3a;
}
.container .settings .settings-panel .sources .source .platform-picker footer button.save {
  background: #232f3a;
  color: #ffffff;
  border-color: #232f3a;
}
.container .settings .settings-panel .dropbox {
  border: 1px dashed #c6d2df;
  width: 35vw;
  height: 20vh;
  margin-top: 15px;
  color: #7d8fa1;
}
.container .settings .settings-panel .dropbox:hover,
.container .settings .settings-panel .dropbox.on-drag {
  border-color: #40c4ff;
  color: #40c4ff;
}
.container .settings .settings-panel .dropbox span {
  display: block;
  float: left;
  position: relative;
  font-size: 17px;
  font-weight: 500;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.container .settings .aside {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  position: relative;
}
.container .settings .aside ul {
  position: absolute;
  top: 15px;
  left: 25%;
  padding: 23px;
  list-style: none;
}
.container .settings .aside ul li {
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 10px;
}
.container .settings .aside ul li:hover {
  font-weight: 700;
}
.container .footer {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
  justify-content: flex-end;
  padding: 0 15px 0 30px;
  align-items: center;
  border-top: 1px solid #dde3e7;
}
.container .footer .btn-save {
  width: 100px;
  height: 30px;
  border-radius: 4px;
  background-color: #232f3a;
  margin: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.container .footer .btn-save span {
  width: 33px;
  height: 12px;
  font-size: 13px;
  line-height: 10px;
  font-weight: 100;
  color: #ffffff;
}
.container .footer .btn-save:hover {
  background-color: #40c4ff;
}
/*# sourceMappingURL=add-or-edit-recording-job.component.css.map */
